import styles from './join.module.css'
import clickMeImg from '../../assets/gfx/clickme.svg'

function JoinSlide() {
    return (
        <div id="join" className={styles.wrapper}>   
            <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfoIAPtpTdxBjjEwoWNIA5jlwOfm1zmPwFVFoE6s36IR5Wozg/viewform?usp=dialog"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
            >
                <div className={styles.content}>
                    <div className={styles['content-title']}>ORIN WANTS YOU!</div>
                    <div className={styles['content-subtitle']}>- 参加募集中 -</div>
                    <img src={clickMeImg} className={styles.icon} alt="more"></img>
                </div>
            </a>
        </div>
    )
}

export default JoinSlide